import { Button } from 'components';
import { RecoverySucess } from 'components/RecoverySuccess';
import { useFormik } from 'formik';
import { FC, useState } from 'react';
import { useHistory, useParams } from 'react-router-dom';
import { recoveryValidation } from 'schemas';
import { AuthService } from 'services';
import { UserRole } from 'types';

import { Alert, Box, Grid, Paper, TextField, Typography } from '@mui/material';

export const Recovery: FC = () => {
  const [error, setError] = useState('');
  const { token }: any = useParams();
  const [role, setRole] = useState<UserRole>(undefined);
  const { replace } = useHistory();

  const handleSubmit = (values: any) => {
    const data = { password: values.password, token: token };

    AuthService.recover(data)
      .then(
        (data: { role: UserRole }) => {
          setRole(data.role);

          if (data.role === 'tutor') {
            return;
          }

          setTimeout(() => {
            replace(
              data.role === 'admin'
                ? `${process.env.PUBLIC_URL}/admin`
                : process.env.PUBLIC_URL
            );
          }, 6000);
        },
        ({ response }) => setError(response.data.error)
      )
      .catch((error: any) => {
        setError('Não foi possível recuperar sua senha.');
      });
  };

  const formik = useFormik({
    initialValues: {
      password: '',
      confirmPassword: '',
    },
    validationSchema: recoveryValidation,
    onSubmit: handleSubmit,
  });

  if (role) {
    return <RecoverySucess /* role={role}  */ />;
  }

  return (
    <Grid
      container
      direction="column"
      justifyContent="center"
      alignItems="center"
      sx={{ minHeight: '100vh' }}
    >
      <Paper variant="outlined" sx={{ py: 12, px: 8 }}>
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
          }}
        >
          <Typography
            component="h1"
            variant="h5"
            sx={{ fontWeight: 400, fontSize: 34, mb: 2 }}
          >
            Nova senha
          </Typography>
          <Box component="form" onSubmit={formik.handleSubmit}>
            <Grid container spacing="2">
              <Grid item xs={12}>
                <TextField
                  required
                  fullWidth
                  id="password"
                  name="password"
                  label="Nova Senha"
                  type="password"
                  value={formik.values.password}
                  onChange={formik.handleChange}
                  error={
                    formik.touched.password && Boolean(formik.errors.password)
                  }
                  helperText={formik.touched.password && formik.errors.password}
                />
              </Grid>
              <Grid item xs={12} sx={{ mt: 2 }}>
                <TextField
                  required
                  fullWidth
                  id="confirmPassword"
                  name="confirmPassword"
                  label="Confirmar Senha"
                  type="password"
                  value={formik.values.confirmPassword}
                  onChange={formik.handleChange}
                  error={
                    formik.touched.confirmPassword &&
                    Boolean(formik.errors.confirmPassword)
                  }
                  helperText={
                    formik.touched.confirmPassword &&
                    formik.errors.confirmPassword
                  }
                />
              </Grid>
              {error && (
                <Grid item xs={12} sx={{ mt: 2 }}>
                  <Alert severity="error">{error}</Alert>
                </Grid>
              )}
            </Grid>
            <Grid item xs={12}>
              <Button
                fullWidth
                type="submit"
                sx={{ mt: 3, mb: 2, color: '#FFFFFF', p: 1 }}
              >
                Salvar
              </Button>
            </Grid>
          </Box>
        </Box>
      </Paper>
    </Grid>
  );
};

